/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setDataCountUp.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import scrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(scrollTrigger);

/**
 * カウントアップ処理
 */
const shuffleNumberCounter = (target) => {
    const targetNum = Number(target.getAttribute('data-num'))

    if (!targetNum) {
        return
    }

    let counterData = null
    const speed = 400 / targetNum
    let initNum = 0

    const countUp = () => {
        if (Number.isInteger(targetNum)) {
            target.innerHTML = initNum
        } else {
            target.innerHTML = `${initNum}.${Math.floor(Math.random() * 9)}`
        }

        initNum++

        if (initNum > targetNum) {
            target.innerHTML = targetNum
            clearInterval(counterData)
        }
    }

    counterData = setInterval(countUp, speed)
}


/**
 * スクロール処理
 */
const Trigger = document.querySelectorAll(".trigger");
for (let i = 0; i < Trigger.length; i++) {
    const target = Trigger[i].querySelectorAll('.count');
    for (let j = 0; j < target.length; j++) {
        gsap.to(Trigger[i].querySelectorAll(".count"), {
            scrollTrigger: {
                trigger: Trigger[i],
                start: "top 75%",
                // markers: true,
                onEnter: () => shuffleNumberCounter(target[j]),
            },
        });
    }
}